<template>
  <accordion-item-fi
    v-if="hasTextList || assemblyMedia || instructionPdf"
    ref="accordionItem"
    class="accordion-assembly-instructions-fi"
    header-tag="h3"
    ignore-others
    scroll-to
    @accordion-item-toggle="triggerResize"
  >
    <template #header>
      <template v-if="!isFite">
        {{ $dict.get('product-Catalog.Accordions.Assembly-Instructions') }}
      </template>
      <template v-else>
        {{ $dict.get('product-Catalog.Accordions.Assembly-Instructions-Fite') }}
      </template>
    </template>
    <template #content>
      <grid-columns-fi
        :columns="12"
        grid-class="lg:fi-grid-cols-10"
      >
        <div class="accordion-assembly-instructions-fi__text-container">
          <richtext-fi
            v-if="textListValue(textList, 'KAT_FUNKTION')"
            class="accordion-assembly-instructions-fi__text"
            :html-content="{ value: textListValue(textList, 'KAT_FUNKTION') }"
          />
        </div>

        <div
          v-if="instructionPdf?.Url"
          class="accordion-assembly-instructions-fi__download"
        >
          <button-fi
            :href="instructionPdf.Url"
            target="_blank"
            rel="noopener noreferrer"
            class="accordion-assembly-instructions-fi__download-button button-fi__primary button-fi--small"
            natural-events
            @click="handleDownload"
          >
            <icon-fi icon="download" />
            <template v-if="!isFite">
              {{ $dict.get('product-Catalog.Accordions.Assembly-Instructions-PDF-Button') }}
            </template>
            <template v-else>
              {{ $dict.get('product-Catalog.Accordions.Assembly-Instructions-PDF-Button-Fite') }}
            </template>
          </button-fi>
        </div>
      </grid-columns-fi>

      <div
        v-if="assemblyMedia"
        class="accordion-assembly-instructions-fi__assembly-media"
      >
        <div
          v-for="(item, index) in assemblyMedia"
          :key="item.Name"
          class="accordion-assembly-instructions-fi__assembly-media--group"
        >
          <div
            v-if="assemblyMediaTitle(item)"
            class="accordion-assembly-instructions-fi__assembly-media-title"
          >
            {{ assemblyMediaTitle(item) }}
          </div>

          <assembly-instructions-media-slider-fi
            :media-items="item.media"
            :class="{
              'accordion-assembly-instructions-fi__assembly-media-slider': true,
              'accordion-assembly-instructions-fi__assembly-media-slider--no-media-title':
                !assemblyMediaTitle(item) && index !== 0,
            }"
          />
        </div>
      </div>
    </template>
  </accordion-item-fi>
</template>

<script>
import { AccordionItemFi, ButtonFi, IconFi, RichtextFi } from 'atoms';
import AssemblyInstructionsMediaSliderFi from 'components/catalog-accordions/accordion-assembly-instructions/assembly-instructions-media-slider/AssemblyInstructionsMediaSliderFi';
import GridColumnsFi from 'components/grid-fi/GridColumnsFi';
import breakpointMixin from 'mixins/breakpointMixin';
import catalogMixin from 'mixins/catalogMixin';

import eventHubMixin from '@/mixins/eventHubMixin.vue';

export default {
  name: 'AccordionAssemblyInstructionsFi',
  components: {
    AccordionItemFi,
    ButtonFi,
    GridColumnsFi,
    IconFi,
    RichtextFi,
    AssemblyInstructionsMediaSliderFi,
  },
  mixins: [breakpointMixin, catalogMixin, eventHubMixin],
  props: {
    catalogData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    textList() {
      return this.catalogData?.TextList;
    },
    hasTextList() {
      return this.textListValue(this.textList, 'KAT_FUNKTION');
    },
    assemblyMedia() {
      if (!this.catalogData?.AssemblyMedia) {
        return null;
      }

      const withMedia = this.catalogData.AssemblyMedia.filter(
        (assemblyMedia) => assemblyMedia.media?.length,
      );

      return withMedia.length ? withMedia : null;
    },
    instructionPdf() {
      return this.catalogData?.Documents?.AdditionalDocuments?.find(
        (document) => document.Type === 'Installation Instructions',
      );
    },
  },
  methods: {
    triggerResize(isOpen) {
      if (IS_SSR || !isOpen) {
        return;
      }

      window.dispatchEvent(new Event('resize'));
    },
    assemblyMediaTitle(item) {
      if (!item) {
        return;
      }
      return this.textListValue(item.media[0].TextList, 'KAT_NEU_PRODBILD');
    },
    handleDownload() {
      this.sendEvent('custom', {}, 'download', {
        link: this.instructionPdf.Url,
        name: 'Installation Instructions',
      });
    },
    openAccordion() {
      this.$refs.accordionItem.toggleAccordion(0);
    },
  },
};
</script>

<style lang="scss">
@import './accordion-assembly-instructions-fi.scss';
</style>
